export default __webpack_public_path__ + "static/media/ARTIST-10 (2-3).42fc96ab.jpg";